const FONT_SIZE_PX = 18;

export const convertFontSizePercentageToPx = (fontSizePercentage: number): number => {
  return (fontSizePercentage / 100) * FONT_SIZE_PX;
};
